<template>
	<div class="acdc-limit-access-contain">
		<section class="limit-access-banner">
			<img alt="" src="@/assets/img/dc/banner.png"/>
		</section>
		<section class="limit-accsss-content">
			<el-form ref="limitForm" :model="form" :rules="rules">
				<el-form-item :label="$t('assessment.limitAccessRole')" prop="user">
					<el-button type="primary"
						@click="addUser()"> {{ $t('assessment.limitSelect') }}
					</el-button>
				</el-form-item>
				<div class="limit-user-list">
					<el-table :data="form.user" border>
						<el-table-column  v-for="item in columnList"
															:key="item.value"
															:prop="item.value"
															:label="item.label"
															header-align="center"
															align="center"></el-table-column>
						<!-- 操作 -->
						<el-table-column :label="$t('handle')"
															fixed="right"
															header-align="center"
															align="center"
															width="100">
							<template slot-scope="scope">
								<el-link type="primary"  :underline="false" @click="deleteRow(scope.$index)">{{ $t('delete') }}
								</el-link>
							</template>
						</el-table-column>
          </el-table>
				</div>
				<el-form-item :label="$t('assessment.limitSetInvalid')" prop="settingStatus">
					<el-tooltip effect="dark" placement="right" popper-class="acdc-limit-access-tooltip">
						<div slot="content">{{ $t('assessment.invalidInfo') }}</div>
						<em class="el-icon-question limit-question-info"></em>
					</el-tooltip>
					<div class="limit-select-module">
						<el-select v-model="form.settingStatus"
											 clearable
											 :disabled="form.user.length===0"
											 :placeholder="$t('user.select')"
											 @change="queryAllSetting">
							<el-option :label="$t('user.setting')" :value="1"></el-option>
							<el-option :label="$t('assessment.noSetting')" :value="0"></el-option>
						</el-select>
					</div>
					<div class="limit-select-module limit-select-module3" v-if="form.settingStatus===1">
						<el-tooltip class="item" effect="dark" placement="right" :disabled="!this.form.settingRoles || this.form.settingRoles.length<38">
              <div slot="content" v-html="settingRoleContent"></div>
							<el-select v-model="form.settingRoles"
												clearable
												@clear="clearSettingChose"
												:placeholder="$t('user.select')">
								<el-option :value="settingValue" style="height: auto">
									<el-tree :data="positionData" class="limit-tree" show-checkbox node-key="jobId" ref="tree" highlight-current :props="defaultProps"
									@check-change="handleCheckChange"></el-tree>
								</el-option>
							</el-select>
						</el-tooltip>
					</div>
				</el-form-item>
				<el-form-item :label="$t('assessment.limitAccessApply')" prop="limitStatus">
					<el-tooltip effect="dark" placement="right" popper-class="acdc-limit-access-tooltip">
						<div slot="content">{{ $t('assessment.limitInfo') }}</div>
						<em class="el-icon-question limit-question-info"></em>
					</el-tooltip>
					<div class="limit-select-module limit-select-module2">
						<el-select v-model="form.limitStatus"
											 clearable
											 :disabled="form.user.length===0"
											 :placeholder="$t('user.select')">
							<el-option :label="$t('assessment.limit')" :value="1"></el-option>
							<el-option :label="$t('assessment.noLimit')" :value="0"></el-option>
						</el-select>
					</div>
					<div class="limit-select-module limit-select-module3" v-if="form.limitStatus===1">
						<el-tooltip class="item" effect="dark" placement="right" :disabled="!this.form.limitRoles || this.form.limitRoles.length<38">
              <div slot="content" v-html="limitRoleContent"></div>
							<el-select v-model="form.limitRoles"
												clearable
												class="limit-select-drown"
												@clear="clearSettingChose2"
												:placeholder="$t('user.select')">
									<el-option :value="limitValue" style="height: auto">
										<el-tree :data="keyPositionArrs" class="limit-tree" show-checkbox node-key="jobId" ref="tree2" highlight-current :props="defaultProps"
										@check-change="handleCheckChange2"></el-tree>
									</el-option>
							</el-select>
						</el-tooltip>
					</div>
				</el-form-item>
				<el-form-item :label="$t('assessment.factoryEvaluation')" prop="desc">
					<el-tooltip effect="dark" placement="right" popper-class="acdc-limit-access-tooltip">
						<div slot="content">{{ $t('assessment.factoryInfo') }}</div>
						<em class="el-icon-question limit-question-info"></em>
					</el-tooltip>
					<div class="limit-input-content">
						<el-input
							type="textarea"
							:placeholder="$t('user.inputContent')"
							v-model="form.desc"
							maxlength="500"
							resize="none"
							show-word-limit
						/>
					</div>
				</el-form-item>
				<el-form-item :label="$t('assessment.factoryFile')">
					<el-tooltip effect="dark" placement="right" popper-class="acdc-limit-access-tooltip">
						<div slot="content">{{ $t('assessment.factoryFileInfo') }}</div>
						<em class="el-icon-question limit-question-info"></em>
					</el-tooltip>
					<div class="acdc-limit-file">
						<el-upload
							class="import-pdf"
							ref="upload"
							accept=".pdf"
							:disabled="form.user.length===0"
							action=""
							:show-file-list="false"
							:multiple="false"
							:http-request="uploadFactoryFile"
							:before-upload="beforeExcelUpload"
							:on-change="changeFile">
							<el-input v-model="fileName" disabled class="import-excel-input" style="width: 200px;"></el-input>
							<div v-if="fileName" class="import-pdf-clear">
                <em class="el-icon-circle-close" @click.stop="removeFile"></em>
              </div>
							<el-button style="margin-left: 12px;" type="primary" icon="el-icon-upload2" :loading="loading">{{ $t('assessment.factoryFileUpload') }}</el-button>
						</el-upload>
					</div>
				</el-form-item>
				<div class="limit-buttons">
					<!-- 确认 -->
					<el-button type="primary" :disabled="confirmDisabled" @click="confirm()">{{ $t('assessment.confirm') }}
					</el-button>
					<!-- 取消 -->
					<el-button plain class="el-button-columnBtn" @click="cancel()">{{ $t('assessment.cancel') }}
					</el-button>
				</div>
			</el-form>
		</section>
		<!-- 选择限制用户弹框 -->
		<LimitAccessAdd v-if="limitRoleShow" :dialogShow="limitRoleShow" @closeHandler="closeAdd" @choseUser="choseUser"></LimitAccessAdd>
	</div>
</template>

<script>
import LimitAccessAdd from './limitAccessAdd'

export default {
	components: {
		LimitAccessAdd
	},
	data() {
		return {
			form: {
				limitStatus: '',
				settingStatus: '',
				settingRoles: '',
				limitRoles: '',
				desc: '',
				user: []
			},
			userId: '',
			limitRoleShow: false,
			columnList: [
				{ value: 'dealerName', label: this.$t('assessment.dealerName') },
				{ value: 'userCode', label: this.$t('user.userID') },
				{ value: 'userCardNo', label: this.$t('user.userCardNo') },
				{ value: 'userNameCn', label: this.$t('user.name') },
				{ value: 'cardNo', label: this.$t('areaManager.passportIdcard') },
				{ value: 'positionName', label: this.$t('user.position') }
			],
			settingValue: '',
			limitValue: '',
			keyPositionArrs: [],
			settingRoleList: [],
			limitRoleList: [],
			settingRoleContent: '',
			limitRoleContent: '',
			defaultProps: {
        children: "children",
        label: "jobTitle"
      },
			positionDataOrigin: [
				{
					jobId: 0,
					jobTitle: this.$t('assessment.all'),
					jobCode: 'all'
				}
			],
			positionData: [],
			rules: {
				user: [
					{ required: true, type: "array", len: 1, message: this.$t('assessment.limitAccessRoleValid'), trigger: 'change' }
				],
				settingStatus: [
					{ required: true, message: this.$t('assessment.limitSetInvalidValid'), trigger: 'change' }
				],
				limitStatus: [
					{ required: true, message: this.$t('assessment.limitAccessApplyValid'), trigger: 'change' }
				],
				desc: [
					{ required: true, message: this.$t('assessment.factoryEvaluationValid'), trigger: 'blur' }
				],
			},
			fileName: '',
			uploadUrl: '/acdc/acdcCommon/uploadFile',
			loading: false,
			businessKey: 1,
			confirmDisabled: false,
			factoryFileInfo: {}
		}
	},
	methods: {
		// 删除当前页面
		tabRemove() {
			let tabName = this.$store.state.contentTabsActiveName
			if (tabName === 'home') {
				return false
			}
			this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
				item => item.name !== tabName
			)
			if (this.$store.state.contentTabs.length <= 0) {
				this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
					'home'
				return false
			}
			// 当前选中tab被删除
			if (tabName === this.$store.state.contentTabsActiveName) {
				this.$router.push({name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name})
			}
		},
		cancel() {
			this.dataList = []
			this.form =  {
				limitStatus: '',
				settingStatus: '',
				settingRoles: '',
				limitRoles: '',
				desc: '',
				user: []
			}
			this.settingValue = ''
			this.limitValue = ''
			this.limitRoleContent = ''
			this.settingRoleContent = ''
			this.tabRemove()
		},
		// 提交限制
		confirm() {
			this.$refs.limitForm.validate((valid) => {
				if (valid) {
					// 提交限制
					this.saveLimit()
				} else {
					return false
				}
			})
		},
		// 保存限制信息
		saveLimit() {
			let params = {
				jobRecruitmentFailureFlag: this.form.settingStatus,
				recruitmentRestrictedFlag: this.form.limitStatus,
				remark: this.form.desc,
				userId: this.userId,
				fileName: this.factoryFileInfo.fileName
			}
			if (this.settingValue) {
				params.invalidJobIds = this.settingValue
			}
			if (this.limitValue) {
				params.restrictJobIds = this.limitValue
			}
			this.$request.post(
				'/acdc/restrict/saveRestrictInfo', params
			).then((res) => {
				this.$message({
          message: this.$t('assessment.limitSuccess'),
          type: 'success',
          duration: 1500,
        })
				this.cancel()
			})
		},
		addUser() {
			this.limitRoleShow = true
		},
		closeAdd() {
			this.limitRoleShow = false
		},
		choseUser(val) {
			this.form.user = [...val]
			this.userId = this.form.user[0].userId
			this.$refs.limitForm.validateField('user');
			this.form.settingStatus = null
			this.form.limitStatus = null
			this.form.limitRoles = ''
			this.form.settingRoles = ''
			this.settingValue = ''
			this.limitValue = ''
			this.limitRoleContent = ''
			this.settingRoleContent = ''
			this.factoryFileInfo = {}
		},
		deleteRow(index) {
			this.form.user = []
			this.userId = ''
			this.settingValue = ''
			this.limitValue = ''
			this.form.settingStatus = null
			this.form.limitStatus = null
			this.form.limitRoles = ''
			this.form.settingRoles = ''
			this.form.desc = ''
			this.limitRoleContent = ''
			this.settingRoleContent = ''
			this.factoryFileInfo = {}
			this.$refs.limitForm.validateField('user');
		},
		handleCheckChange() {
      let res = this.$refs.tree.getCheckedNodes(true, true);
      let arrLabel = [];
      let arr = [];
      res.forEach(item => {
        arrLabel.push(item.jobTitle);
        arr.push(item.jobId);
      });
      this.settingValue = arr.join(',');
      this.form.settingRoles = arrLabel.join(',');
			let str = '';
			arrLabel.forEach((item) => {
				str += item + '<br/>'
			})
			this.settingRoleContent = str
    },
		handleCheckChange2() {
      let res = this.$refs.tree2.getCheckedNodes(true, true);
      let arrLabel = [];
      let arr = [];
      res.forEach(item => {
        arrLabel.push(item.jobTitle);
        arr.push(item.jobId);
      });
      this.limitValue = arr.join(',');
      this.form.limitRoles = arrLabel.join(',');
			let str = '';
			arrLabel.forEach((item) => {
				str += item + '<br/>'
			})
			this.limitRoleContent = str
    },
		clearSettingChose() {
			this.$nextTick(() => {
				this.$refs.tree.setCheckedKeys([])
				this.settingRoleContent = ''
				this.form.settingRoles = ''
				this.settingValue = ''
			})
		},
		clearSettingChose2() {
			this.$nextTick(() => {
				this.$refs.tree2.setCheckedKeys([])
				this.limitRoleContent = ''
				this.form.limitRoles = ''
				this.limitValue = ''
			})
		},
		// 设置测评无效 获取职位列表
		queryAllSetting() {
			if (this.form.settingStatus === 1) {
				this.$request.get(
					'/acdc/restrict/listEffectiveRecruitment',
					{
						userId: this.userId
					}
				).then((res) => {
					if (res) {
						if (res.length > 0) {
							let data = JSON.parse(JSON.stringify(this.positionDataOrigin[0]))
							Object.assign(data, { children: res })
							this.positionData = [data]
						} else {
							this.positionData = []
						}
					}
				})
			}
		},
		// 获取限制申请职位列表
		queryAllLimit() {
			this.$request.get('/sys/commposition/keyPosition')
				.then((res) => {
					let fdata = JSON.parse(JSON.stringify(this.positionDataOrigin[0]))
					const data = res.map((item) => {
						return  { jobId: item.positionId, jobTitle: item.positionNameCn }
					})
					Object.assign(fdata, { children: data })
					this.keyPositionArrs = [fdata]
				}).catch((err) => {
					console.log(err)
				})
		},
		beforeExcelUpload (file) {
			this.confirmDisabled = true
      const maxLength = 4 * 1024 * 1024
      if (file.size > maxLength) {
        this.$message({
          message: '大小不能超过4M',
          type: 'error',
          duration: 1500,
        })
				this.confirmDisabled = false
				this.fileName = ''
				this.factoryFileInfo = {}
        this.loading = false
        return false
      }
      const fileName = file.name
      const first = fileName.lastIndexOf('.')// 取到文件名开始到最后一个点的长度
      const namelength = fileName.length // 取到文件名长度
      const filesuffix = fileName.substring(first + 1, namelength)// 截取获得后缀名
      if (filesuffix !== 'pdf') {
        this.$message({
          message: '只能上传PDF文件',
          type: 'error',
          duration: 1500,
        })
        this.loading = false
				this.confirmDisabled = false
				this.fileName = ''
			  this.factoryFileInfo = {}
        return false
      }
      return true
    },
		changeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName = file.name
      }
    },
		handleError() {
      this.loading = false
    },
		// 上传文件
		uploadFactoryFile(file) {
			let formData = new FormData()
			formData.append('businessKey', this.businessKey)
			formData.append('file', file.file)
			this.$request.post('/acdc/acdcCommon/uploadFile', formData)
				.then((res) => {
					if (res) {
						this.factoryFileInfo = res
						this.$message({
							message: '上传文件成功',
							type: 'success',
							duration: 1500
						})
						this.confirmDisabled = false
					}
				}).catch(() => {
					this.factoryFileInfo = {}
					this.fileName = ''
					this.confirmDisabled = false
				})
		},
		removeFile() {
			this.fileName = ''
			this.factoryFileInfo = {}
		}
	},
	mounted() {
		this.queryAllLimit()
	}
}
</script>

<style lang="scss" scoped>
.acdc-limit-access-contain {
	.limit-access-banner {
		margin-bottom: 10px;
		img {
			display: inline-block;
    	width: 100%;
		}
	}
	.limit-question-info {
		color: #5C9DF5 !important;
	}
	.limit-accsss-content {
		border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
		height: calc(100% - 208px);
		padding: 30px 110px 20px 110px;
		.limit-user-list {
			margin: 0 0 20px 0;
		}
		.limit-select-module {
			display: inline-block;
			width: 200px;
			margin-left: 20px;
			&.limit-select-module2 {
				margin-left: 48px;
			}
			&.limit-select-module3 {
				width: 38%;
				max-width: 460px;
			}
		}
		.el-form-item {
			margin-bottom: 20px !important;
			width: 100% !important;
			line-height: 32px !important;
		}
		.limit-input-content {
			height: 140px;
			// margin-top: 20px;
		}
		.limit-buttons {
			text-align: center;
		}
	}
	.acdc-limit-file {
		margin-left: 58px;
		display: inline-block;
		.import-pdf-clear {
			position: absolute;
			left: 350px;
			top: 3px;
			z-index: 100;
		}
	}
}
</style>
<style lang="scss">
.limit-input-content {
	.el-textarea {
		height: 100% !important;
		width: 100% !important;
		.el-textarea__inner {
			height: 100% !important;
		}
	}
}
.acdc-limit-access-contain {
	.el-form-item__label {
		line-height: 32px !important;
		padding: 0 12px 0 0 !important;
	}
	.el-form-item__content {
		line-height: 32px !important;
	}
}
.el-select-dropdown__item {
	background-color: #FFF !important;
	font-weight: normal !important;
}
</style>
